import { useEffect, useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { useAdminLanguage } from "@/i18n/AdminLanguage";
import { api, fmtErr } from "@/lib/api";

export default function AdminSettings() {
  const {tr:t}=useAdminLanguage();
  const [handle, setHandle] = useState("");
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/settings")
      .then((r) => setHandle(r.data.telegram_handle))
      .catch((e) => toast.error(fmtErr(e)))
      .finally(() => setLoading(false));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/settings", { telegram_handle: handle });
      setHandle(data.telegram_handle);
      toast.success(t("Telegram handle updated"));
    } catch (err) {
      toast.error(fmtErr(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-settings-panel" className="max-w-lg">
      <h2 className="font-syne text-xl font-extrabold tracking-tight">{t("Settings")}</h2>
      <p className="mt-1 text-xs text-white/40">
        {t("Every purchase button on the site uses the official Telegram bot for linked parties.")}
      </p>

      <form data-testid="settings-form" onSubmit={save} className="mt-6 rounded-xl border border-white/10 bg-ash p-6">
        <label className="mb-1 block text-[10px] font-bold uppercase tracking-[0.2em] text-white/45">
          Telegram handle
        </label>
        <div className="flex items-center gap-2">
          <span className="rounded-lg border border-white/15 bg-coal px-3 py-2 text-sm text-white/40">t.me/</span>
          <input
            data-testid="telegram-handle-input"
            required
            value={handle}
            onChange={(e) => setHandle(e.target.value.replace(/^@/, ""))}
            placeholder="kndlatable"
            disabled={loading}
            className="w-full rounded-lg border border-white/15 bg-coal px-3 py-2 text-sm text-white outline-none transition-colors placeholder:text-white/25 focus:border-flame"
          />
        </div>
        <div className="mt-5 flex items-center gap-3">
          <button
            data-testid="settings-save-btn"
            disabled={saving || loading}
            className="rounded-full bg-flame px-6 py-2.5 text-xs font-bold transition-colors hover:bg-ember disabled:opacity-50"
          >
            {saving ? t("Saving…") : t("Save")}
          </button>
          {handle && (
            <a
              data-testid="settings-telegram-preview"
              href={`https://t.me/${handle}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-xs font-semibold text-white/50 transition-colors hover:text-flame"
            >
              <Send className="h-3.5 w-3.5" /> {t("Open")} @{handle}
            </a>
          )}
        </div>
      </form>
    </div>
  );
}
